import React from "react";
import ImageSlider from "./ImageSlider";
import image1 from '../../Assets/images/partnerImages/Birlasoft-Leads-with-Quality.jpg'
import image2 from '../../Assets/images/partnerImages/Citibank_logo.jpg'
import image3 from '../../Assets/images/partnerImages/at&t.jpg'
import image4 from '../../Assets/images/partnerImages/cox_logo.svg'
import image5 from '../../Assets/images/partnerImages/creditsuisse.png'
import image6 from '../../Assets/images/partnerImages/cognizant-logo.png'

const ProudMembers = () => {

  const members = [
    { src: image1 },
    { src: image2 },
    { src: image3 },
    { src: image4 },
    { src: image5 },
    { src: image6 },
    { src: image3 },
    { src: image5 },
  ];


  return (
    <React.Fragment>
      <div className="w-full h-auto py-10">
        <div className="flex flex-col gap-4 justify-center items-center mx-auto max-w-7xl px-12 sm:px-6 lg:px-8">
          <h1 className="flex justify-center items-center p-4 text-[25px] font-bold text-gray-400 tracking-wider">
            We are proud members of the following associations:
          </h1>
          <ImageSlider images={members}/>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProudMembers;
